import Fieldset from "./Fieldset";
import Address from "./Address";

export default function CorporateAddress({ id, header, state, onChange }) {
  const getAltAddress = () =>
    state.altAddress !== "false" && (
      <Address id="altAddress" isCountyRequired isCorpAddress={false} state={state} onChange={onChange} />
    );

  return (
    <div>
      <Address id={id} isCountyRequired isCorpAddress header={header} state={state} onChange={onChange} />
      <div className="radio">
        <Fieldset
          id="altAddress"
          label="Do you want to receive your mail at another address?"
          questionValue={state.altAddress}
          value={state.altAddress}
          onChange={onChange}
        />
      </div>
      {getAltAddress()}
    </div>
  );
}
